export default class ChangesRegisterDataDialogController {
  constructor(
    $log, $window, $mdDialog, changes
  ) {
    'ngInject';
    this.$log = $log;
    this.$window = $window;
    this.$mdDialog = $mdDialog;
    this.changes = changes;
  }

  closeDialog() {
    this.$mdDialog.hide();
  }
}
